import React from 'react';
import './Modal.css';
import rejectPlanIcon from "../../assets/images/rejectPlanIcon.svg";
import Heading6Semibold from '../designSystem/Heading6Semibold';
import BodyMediumRegular from '../designSystem/BodyMediumRegular';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import Textarea from '../designSystem/TextArea';
import { t } from '../../locales/translate';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";

const RejectPlanModal = ({ isVisible, onClose, onRejectClick, isLoading, message, setMessage, error }) => {
    const [loading, setLoading] = React.useState(false);

    const handleReject = async () => {
        setLoading(true);
        try {
            await onRejectClick();
        } catch (error) {
            console.error("Error rejecting:", error);
        } finally {
            setLoading(false);
        }
    };

    return (
        isVisible && (
            <div className="modal-backdrop">
                <div className="modal-container" onClick={(e) => e.stopPropagation()}>
                    <LoadingOverlay isVisible={loading} />
                    <div className={loading ? 'blur' : ''}>
                        <div className='content-container'>                       
                            <div className='icon-container'>
                                <img src={rejectPlanIcon} alt="Reject Plan" />
                            </div>
                            <div className='text-container'>
                                <Heading6Semibold color='#1E293B' text={t("rejectPlan")} />
                                <BodyMediumRegular
                                    color='#384153'
                                    text={t("rejectPlanTip")}
                                    textAlign='center'
                                />
                            </div>
                            <Textarea
                                label={t("notes")}
                                value={message}
                                onChange={(e) => setMessage(e.target.value)} 
                                error={error}
                                placeholder={t("addSuggestionsHere")}
                            />
                        </div>
                        <div className='button-contiainer'>
                            <button className='cancel-button'
                                onClick={onClose}
                            >
                                <p className="button-text">{t("cancel")}</p>
                            </button>
                            <button className='danger-button' onClick={handleReject} disabled={loading}>
                                <p className="button-text delete">{t("rejected")}</p>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    );
};

export default RejectPlanModal;